import { render, staticRenderFns } from "./AccountSkeletonFormLoader.vue?vue&type=template&id=55d89a3e&scoped=true&"
import script from "./AccountSkeletonFormLoader.vue?vue&type=script&lang=js&"
export * from "./AccountSkeletonFormLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d89a3e",
  null
  
)

export default component.exports